module.exports = __webpack_public_path__ + "static/media/hero@3x.45510a9b.jpg";